module.exports = __webpack_public_path__ + "static/media/404.0ab6bd12.gif";